module.exports = __webpack_public_path__ + "static/img/increased-revenue.560ed1f0.png";